export default __webpack_public_path__ + "images/2704302288786f785bece42982e16edf-baseball.jpg";